import padlockIcon from "../../assets/icons/padlock.svg";

const SecureReassure = ({ children }) => {
    return (
        <div className="secure-reassure">
            <img src={padlockIcon} alt="" />
            {children}
        </div>
    );
};

export default SecureReassure;
